"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ListingContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "file-listing__ListingContainer",
  componentId: "sc-1ducjz4-0"
})(["border-top:1px solid ", ";color:", ";fill:", ";text-decoration:none;", ";&:hover{color:", ";svg{fill:currentColor;transition:inherit;}}cursor:pointer;"], function (props) {
  return (0, _styles.themeTransparentize)(0.5, "border", props);
}, function (props) {
  return (0, _styles.colors)("text-hover", props);
}, function (props) {
  return (0, _styles.colors)("text-hover", props);
}, (0, _styles.defaultTransition)("color"), (0, _styles.themeDarken)(0.15, "text-hover"));
var propTypes = {
  /** file name, usually a text string, but can be a React component */
  children: _propTypes.node,

  /** font config */
  font: _utils.fontPropType,

  /** Glyph node */
  glyph: _propTypes.node,

  /** behaviour html tag */
  tag: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]),

  /** File url */
  url: _propTypes.string,

  /** A string used to Cta style */
  version: _propTypes.string
};
var defaultProps = {
  tag: "a"
};
var containerStyles = {
  alignItems: "center",
  justifyContent: "flex-start",
  lineHeight: 0,
  px: [2, 2, 2, 2, 2],
  py: [2, 4, 2, 2, 2],
  width: 1
};

var FileListing = function FileListing(_ref) {
  var tag = _ref.tag,
      children = _ref.children,
      glyph = _ref.glyph,
      version = _ref.version,
      font = _ref.font,
      url = _ref.url;
  var urlAttrs = (0, _react.useMemo)(function () {
    return url ? {
      as: tag,
      href: url,
      rel: "noopener",
      target: "_blank"
    } : {
      as: "span"
    };
  }, [tag, url]);
  return /*#__PURE__*/_react["default"].createElement(ListingContainer, _extends({}, urlAttrs, containerStyles), glyph && /*#__PURE__*/_react["default"].createElement(_components.ButtonGlyph, {
    animateGlyph: false,
    mr: 1,
    version: version
  }, glyph || /*#__PURE__*/_react["default"].createElement(_components.DocumentsGenericDocument, null)), children && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, font, children));
};

FileListing.propTypes = propTypes;
FileListing.defaultProps = defaultProps;
FileListing.displayName = "Modules.FileListing";
var _default = FileListing;
exports["default"] = _default;